import classNames from 'classnames';
import { GuideTypes, IGuide } from 'common/interfaces';
import { FC } from 'react';

import styles from './Guide.module.scss';
import useGuide from './hooks/useGuide';

interface IProps {
  guideData: IGuide;
}

const Guide: FC<IProps> = ({ guideData }) => {
  const { elemRef, isSelected } = useGuide(guideData);

  return (
    <div
      className={classNames(styles.guide, {
        [styles.vertical]: guideData.type === GuideTypes.VERTICAL,
        [styles.selected]: isSelected,
      })}
      style={{ left: guideData.x, top: guideData.y }}
      ref={elemRef}
    >
      <div className={styles.handler} data-guide-drag-target />
    </div>
  );
};

export default Guide;
